import React from 'react';
import { ReactSortable } from 'react-sortablejs';

import styles from './OrderableList.module.scss';

export interface ListEntry {
  id: string | number;
  name: React.ReactNode;
}

export interface OrderableListProps {
  list: ListEntry[];
  onReorder: (inputs: ListEntry[]) => void;
}

export const OrderableList: React.FC<OrderableListProps> = ({ list, onReorder }) => (
  <ol className={styles.orderedList}>
    <ReactSortable
      className={styles.list}
      list={list}
      setList={onReorder}
      animation={200}
      easing="ease-out"
      ghostClass={styles.ghost}
    >
      {list.map(entry => (
        <li
          className={styles.item}
          key={entry?.id}
        >
          {entry?.name}
        </li>
      ))}
    </ReactSortable>
  </ol>
);
